import { render, staticRenderFns } from "./BatchAboveOrUnder.vue?vue&type=template&id=3d1091d9&"
import script from "./BatchAboveOrUnder.vue?vue&type=script&lang=js&"
export * from "./BatchAboveOrUnder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports